/* eslint eqeqeq: 'off' */ 
let mHeatCoolValue = undefined;
///Temperature Widget Related Constants
// let m_ReadResult = null, changes, mOffsetValue = 0, mZoneName = null, mIsAnalogDifferential = false;

export default class TemperatureScripts {

    static setHeatCoolvisible(a_ControlObjectType, a_heatCollValue) {        
                switch (a_ControlObjectType){
                    case 155:                        
                    case 154:
                    case 170:
                    if (Number(a_heatCollValue == 0)) mHeatCoolValue = "COOL"; else mHeatCoolValue = "HEAT";
                        break;
                    case 164:
                        switch(Number(a_heatCollValue))
                        {
                            case 0:
                            case 1:
                            case 2:
                            case 3:                                                            
                                mHeatCoolValue = "COOL";
                                break;
                            case 4:
                            case 5:                                                          
                                mHeatCoolValue = "HEAT";
                                break;
                            default:break;
                        }                      
                        break;   
                    case 169:
                    case 185:
                    case 150:
                    case 165:
                    case 178:
                    case 130:
                        if (Number(a_heatCollValue == 0)) mHeatCoolValue = "HEAT"; else mHeatCoolValue = "COOL";
                        break;
                    default: break;
                }
      
        return mHeatCoolValue;
    }


    // To Do : delete the below function while removing After Hours OLD code
  
    static DetermineDisabledState(a_StatusReadResult){
        let HasDisable = false;
        if (a_StatusReadResult !== null) {
            let outOfService = (a_StatusReadResult["outOfService"].displayValue !== "---") ? Number(a_StatusReadResult["outOfService"].displayValue) : ""; //Number(a_StatusReadResult.DataPointValues[6].DisplayValue);
            let activePriority = (a_StatusReadResult["activePriority"].displayValue !== "---") ? Number(a_StatusReadResult["activePriority"].displayValue) : 0; //Number(a_StatusReadResult.DataPointValues[5].DisplayValue); 
            let controllingpriority = 8; //Default Control Priority for Tenant is 8
            //let requestMinValue = Number(a_StatusReadResult.DataPointValues[2].DisplayValue); 
            //let requestMaxValue = Number(a_StatusReadResult.DataPointValues[3].DisplayValue); 
            let occupancyStatus = (a_StatusReadResult["occupancyStatus"].displayValue !== "---") ? Number(a_StatusReadResult["occupancyStatus"].displayValue) : "---"; //Number(a_StatusReadResult.DataPointValues[9].DisplayValue); 
            let StatusValue = a_StatusReadResult["statusValue"].displayValue;
            let RequestValue = a_StatusReadResult["requestValue"].displayValue;
            let HeatCoolMode = a_StatusReadResult["heatCoolValue"].displayValue;
            let OffsetValue = a_StatusReadResult["offsetValue"].displayValue;
            

            if (!outOfService) {
                // if we aren't out of service, then check to see if we are overridden at a higher priority
                HasDisable = ((activePriority < controllingpriority) && (activePriority !== 0));
                
                // when the min is greater than or equal to the max disable the widget
                // if (requestMinValue >= requestMaxValue) {
                //     HasDisable = true;
                // }

                // when unoccupied disable both buttons
                // or 'disabled' property of the controller is true
                if(occupancyStatus === "---" || occupancyStatus === 2){
                    HasDisable = true;
                }

                //if Status Value is null
                if(StatusValue == "---" || RequestValue == "---" || HeatCoolMode == "---" || OffsetValue == "---")
                {
                    HasDisable = true;
                }
            }else{
                //points are offline or in Fault the widget is Disabled 
                HasDisable = true;
            }
        }

        return HasDisable;
    }


        
    static DetermineDisabledStateUpdated(a_StatusReadResult){
        let HasDisable = false;
        let disabledCodeNumber = 0;
        if (a_StatusReadResult !== null) {
            let outOfService = (a_StatusReadResult["outOfService"].displayValue !== "---") ? Number(a_StatusReadResult["outOfService"].displayValue) : ""; //Number(a_StatusReadResult.DataPointValues[6].DisplayValue);
            let activePriority = (a_StatusReadResult["activePriority"].displayValue !== "---") ? Number(a_StatusReadResult["activePriority"].displayValue) : 0; //Number(a_StatusReadResult.DataPointValues[5].DisplayValue); 
            let controllingpriority = 8; //Default Control Priority for Tenant is 8
            //let requestMinValue = Number(a_StatusReadResult.DataPointValues[2].DisplayValue); 
            //let requestMaxValue = Number(a_StatusReadResult.DataPointValues[3].DisplayValue); 
            let occupancyStatus = (a_StatusReadResult["occupancyStatus"].displayValue !== "---") ? Number(a_StatusReadResult["occupancyStatus"].displayValue) : "---"; //Number(a_StatusReadResult.DataPointValues[9].DisplayValue); 
            let StatusValue = a_StatusReadResult["statusValue"].displayValue;
            let RequestValue = a_StatusReadResult["requestValue"].displayValue;
            let HeatCoolMode = a_StatusReadResult["heatCoolValue"].displayValue;
            let OffsetValue = a_StatusReadResult["offsetValue"].displayValue;
            

            if (!outOfService) {
                // if we aren't out of service, then check to see if we are overridden at a higher priority
                HasDisable = ((activePriority < controllingpriority) && (activePriority !== 0));
                if(HasDisable){
                    disabledCodeNumber= 4;
                }
                // when the min is greater than or equal to the max disable the widget
                // if (requestMinValue >= requestMaxValue) {
                //     HasDisable = true;
                // }

                // when unoccupied disable both buttons
                // or 'disabled' property of the controller is true
                if(occupancyStatus === "---" || occupancyStatus === 2){
                    HasDisable = true;
                    disabledCodeNumber= 3;
                }

                //if Status Value is null
                if(StatusValue == "---" || RequestValue == "---" || HeatCoolMode == "---" || OffsetValue == "---")
                {
                    HasDisable = true;
                    disabledCodeNumber= 2;
                }
            }else{
                //points are offline or in Fault the widget is Disabled 
                HasDisable = true;
                disabledCodeNumber= 1;
            }
        }
        let data = {};
        data.isDisable = HasDisable;
        data.Code = disabledCodeNumber;
        

        return data;
    }


}



//Code 0:  Widget enabled(working, both buttons enabled).
//Code 1:   out of points are offline or in Fault the widget is Disabled 
//Code 2:  Status Value is null
//Code 3:  when unoccupied or 'disabled' property of the controller is true
//Code 4:  if we aren't out of service, then check to see if we are overridden at a higher priority
